// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39PjL","content":"styles_content__28iIp","row":"styles_row__2jpVr","footer":"styles_footer__32W52","phraseLength":"styles_phraseLength__aWefa"};